export default __webpack_public_path__ + "static/media/whyus.799ed98d.jpg";